export default "__VITE_ASSET__JOVw$6Go__"